"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcButton_1 = require("../../button/AcButton");
var AcModal_1 = require("../../modal/AcModal");
var react_bootstrap_1 = require("react-bootstrap");
exports.NotPersonInCharge = function (_a) {
    var closeNotPersonInChargeModal = _a.closeNotPersonInChargeModal;
    return (react_1.default.createElement(AcModal_1.AcModal, { show: true, staticBackdrop: true, level: 2 },
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "p-4" },
            react_1.default.createElement("h4", { className: "h4 text-center mb-6" }, "\u62C5\u5F53\u306E\u5909\u66F4\u304C\u5FC5\u8981\u3067\u3059"),
            react_1.default.createElement("p", { className: "text-center" },
                "\u9078\u629E\u3057\u305F\u30C7\u30FC\u30BF\u306F\u3001\u4ED6\u306E\u65B9\u304C\u62C5\u5F53\u3055\u308C\u3066\u3044\u308BFAX\u3067\u3059\u3002",
                react_1.default.createElement("br", null),
                "\u62C5\u5F53\u3092\u81EA\u5206\u306B\u5909\u66F4\u3059\u308B\u3053\u3068\u3067\u7DE8\u96C6\u30FB\u8FD4\u4FE1\u304C\u53EF\u80FD\u3068\u306A\u308A\u307E\u3059\u3002")),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, { className: "d-flex justify-content-center py-3" },
            react_1.default.createElement(AcButton_1.AcButton, { width: "60%", size: "lg", variant: "outline-apzlinkblue", onClick: closeNotPersonInChargeModal }, "\u30AD\u30E3\u30F3\u30BB\u30EB"))));
};
exports.NotPersonInCharge.displayName = 'NotPersonInCharge';
//# sourceMappingURL=NotPersonInCharge.js.map